"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const colorbar = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 1000 4",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-colorbar" : '') + (description ? " desc-colorbar" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-colorbar"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-colorbar"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "ColorBar-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "ColorBar-2",
    transform: "translate(-232.000000, -588.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "ColorBar-3",
    transform: "translate(-8.000000, 564.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "ColorBar-4",
    transform: "translate(240.000000, 24.000000)"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    id: "path-1",
    x: "0",
    y: "0",
    width: "1000",
    height: "4"
  })), /*#__PURE__*/_react.default.createElement("rect", {
    id: "path-1",
    fill: "#F69DBD",
    x: "0",
    y: "0",
    width: "1000",
    height: "4"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "WildStreak",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Shape",
    transform: "translate(1087.500000, -535.500000) rotate(-90.000000) translate(-1087.500000, 535.500000) translate(-191.500000, -1963.500000)"
  }, /*#__PURE__*/_react.default.createElement("polygon", {
    fill: "#F47D39",
    points: "2219.75886 622.152542 48.5443755 753 13.3586863 344.374294 2184.28711 174"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    fill: "#F47D39",
    points: "13.3586863 1057 2557.40874 1215.62185 2557.40874 1324.60504 13.3586863 1387"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    fill: "#FCDCE2",
    points: "174.954192 898.632867 744.954192 863 744.954192 1172.37063 174.954192 1258"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    fill: "#EF426D",
    points: "2240.3129 1304 9.44434412 1045.04351 0 871 2254.05013 1000.05649"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    fill: "#EF4B22",
    points: "2323.96361 532 145.94987 387.553279 174.049574 0 2352.35004 143.356557"
  })))))))));
};
var _default = exports.default = colorbar;